import * as React from "react";

const AudioContext = React.createContext(null);

export const AudioContextProvider = ({ children }) => {
  const audioFile = React.useRef(new Audio());
  const playing = React.useRef(false);
  const setLastChildPlaying = React.useRef(() => {});

  const handleAudioEnd = () => {
    audioFile.current.pause();
    audioFile.current.removeEventListener("ended", () => handleAudioEnd());
    setLastChildPlaying.current();
    playing.current = false;
  };

  const audio = {
    play: (url, setChildPlaying) => {
      if (playing.current) {
        audioFile.current.pause();
        playing.current = false;
        setLastChildPlaying.current();
      }
      audioFile.current = new Audio(url);
      audioFile.current.play();
      audioFile.current.addEventListener("ended", () => handleAudioEnd());
      setLastChildPlaying.current = setChildPlaying;
      playing.current = true;
    },
    pause: () => {
      audioFile.current.pause();
      playing.current = false;
      setLastChildPlaying.current();
    },
  };

  return (
    <AudioContext.Provider value={audio}>{children}</AudioContext.Provider>
  );
};

export const useAudio = () => {
  return React.useContext(AudioContext);
};
